import React, { useState } from 'react';
import { Button, message, Steps, theme, Form, Space, notification } from 'antd';
import CreateSalons from './CreateSalons';
import CreateUser from './CreateUser';

import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined } from "@ant-design/icons";
import SalonAddress from './SalonAddress';
import SalonRequest from './SalonRequest';
import UploadSaloonImage from './UploadSaloonImage';


const { Step } = Steps;
const UserSteps = () => {
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(false);
  const [salonId, setSalonId] = useState();
  const [saloonImage, setSaloonImage] = useState([])
  const [salonNewId, setSalonNewId] = useState();

  const next = () => {
    forms[current][0]
      .validateFields()
      .then(() => {
        setCurrent((prev) => prev + 1);
      })
      .catch(() => {
        message.error('Please fill in the required fields.');
      });
  };

  const prev = () => {
    setCurrent((prev) => prev - 1);
  };


  const onFinishUser = (values) => {
    setLoading(true);
    const allFormData = { ...values };
    console.log(allFormData)
    SalonRequest.createSalon(allFormData)
      .then((res) => {
        if (res.status === 201) {
          notification.success({
            message: "Saloon user added successfully",
          });
          setSalonId(res?.data?.data?.userId);
          next();
        } else {
          notification.error({
            message: "Something went wrong",
          });
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);

      });
  };

  const onFinishCreateSalon = (values) => {
    setLoading(true);
    const allFormData = {
      ...values, workingDays: [1, 2, 3, 4, 5, 6 , 7],
      workingHours: {
        "openingTime": "09:00:00 am",
        "closingTime": "06:00:00 pm",
        "lunchTime": {
          "start": "01:00:00 pm",
          "end": "02:00:00 pm"
        }
      }, salonUserId: salonId, isOpeningTimeSame: 1
    };

    SalonRequest.createSalonUser(allFormData)
      .then((res) => {
        if (res.status === 201) {
          notification.success({
            message: "Saloon added successfully",
          });
          setSalonNewId(res?.data?.data?.salonId)
          next();
        } else {
          notification.error({
            message: "Something went wrong",
          });
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        console.error("API Error:", e);
      });
  };

  const onFinishUploadImage = (values) => {
    const allFormData = {
      salonId: salonNewId, salonImages: saloonImage
    };
    console.log(allFormData)
    SalonRequest.uploadSaloonImage(allFormData)
      .then((res) => {
        if (res.status === 201) {
          notification.success({
            message: "Saloon image uploaded successfully",
          });

          next();
        } else {
          notification.error({
            message: "Something went wrong",
          });
        }

      })
      .catch((e) => {
        console.error("API Error:", e);
      });
  };

  const onFinishCreateAddress = (values) => {
    setLoading(true);
    const allFormData = {
      ...values,
      salonId: salonNewId, country: 'india'
    };
    SalonRequest.createSalonAddress(allFormData)
      .then((res) => {
        if (res.status === 201) {
          notification.success({
            message: "Salon added successfully",
          });
          navigate(-1);
        } else {
          notification.error({
            message: "Something went wrong",
          });
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        console.error("API Error:", e);
      });
  };


  const [forms] = useState([Form.useForm(), Form.useForm(), Form.useForm(), Form.useForm()]);
  const steps = [
    {
      title: 'Create User',
      content: <CreateUser form={forms[0][0]} onFinishUser={onFinishUser} setLoading={setLoading} />,
    },
    {
      title: 'Create Salon',
      content: <CreateSalons form={forms[1][0]} current={current} prev={prev} onFinishCreateSalon={onFinishCreateSalon} />,
    },
    {
      title: 'Upload Images',
      content: <UploadSaloonImage form={forms[2][0]} current={current} setSaloonImage={setSaloonImage} prev={prev} onFinishUploadImage={onFinishUploadImage} setLoading={setLoading} />,
    },
    {
      title: 'Address',
      content: <SalonAddress form={forms[3][0]} onFinishCreateAddress={onFinishCreateAddress} current={current} prev={prev} />,
    },
  ];


  const navigate = useNavigate()




  return (
    <>
      <Form.Item className="submit-btn">
        <Space>
          <Button className="f-sub-btn btn-width" onClick={() => navigate(-1)} disabled={loading}>
            <ArrowLeftOutlined />
          </Button>
        </Space>
      </Form.Item>
      <Steps current={current}>
        {steps.map((item, index) => (
          <Step key={index} title={item.title} />
        ))}
      </Steps>
      <div className="steps-content" style={{ marginTop: '16px' }}>
        {steps[current].content}
      </div>

    </>


  );
};
export default UserSteps;